import { useEffect, useRef, ReactNode } from "react";
import { supabase } from "@/integrations/supabase/client";

interface TrackedSectionProps {
  children: ReactNode;
  sectionId: string;
  eventName: string;
}

const TrackedSection = ({ children, sectionId, eventName }: TrackedSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const tracked = useRef(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      async (entries) => {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting && !tracked.current) {
            tracked.current = true;
            try {
              await supabase.from("meta_pixel_events").insert([{
                event_name: eventName,
                event_data: { section: sectionId },
                page_url: window.location.href,
              }]);
            } catch (error) {
              console.error("Failed to log section view:", error);
            }
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% of section is visible
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [sectionId, eventName]);

  return <div ref={ref}>{children}</div>;
};

export default TrackedSection;
